import React, {Fragment} from "react";
import isEqual from "lodash-es/isEqual";
import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import {postData} from "../../utils/request";
import {CurrencyFormatter} from "../../utils/formatters";
import Button from "../form/Button";
import PaymentWriteOffForm from "./forms/PaymentWriteOffForm";
import PaymentWriteOffList from "./lists/PaymentWriteOffList";
import Box from "../layout/Box";
import BoxEditor from "./BoxEditor";
import createEditor from "../form/ComponentEditor";
import ComponentConfig from "../form/ComponentConfig";
import InvoiceList from "./lists/invoiceList";

export class PaymentWriteOffButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            opened: false,
            amount: this.props.transaction.balance
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.transaction.balance, prevProps.transaction.balance)) {
            this.setState({
                amount: this.props.transaction.balance
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        header="Leírás"
                        size="small"
                        state={this.state.opened}
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: "Leírás",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClick: async () => {
                                    try {
                                        this.setState({isLoading: true});
                                        await postData({
                                            action: 'PaymentWriteOff.create',
                                            data: {
                                                transaction: this.props.transaction.id,
                                            }
                                        });
                                        this.props.callBack && this.props.callBack();
                                        this.setState({opened: false, isLoading: false});
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }
                            }
                        ]}
                    >
                        <b>Biztos? {CurrencyFormatter(this.state.amount).props.children} leírás lesz hozzáadva!</b>
                    </Modal>
                </Portal>
                <Button
                    disabled={this.state.amount == 0}
                    icon={{lib: "fas", name: "hands-helping"}}
                    size="xs"
                    color="default"
                    tooltip="Leírás"
                    onClick={(e) => {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                        this.setState({opened: true});
                        return false;
                    }}
                />
            </Fragment>
        );
    }
}

class PaymentWriteOffEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield]) {
            props.disabled = props.disabled || true;
        }
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Leírások"
                footer={[
                    <Button
                        key="0"
                        className="pull-left"
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                ]}
            >
                <PaymentWriteOffList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Leírás"
                footer={[
                    <Button
                        key="0"
                        disabled={!this.props.dirty || this.props.isLoading || (this.props.values.amount || 0) + "" === "0"}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>,
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.props.deleteForm}
                    >
                        Törlés
                    </Button>
                ]}
            >
                <PaymentWriteOffForm {...this.props} getFieldProps={this.getFieldProps} />
            </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "PaymentWriteOff",
    WrappedComponent: PaymentWriteOffEditor
});